import { render, staticRenderFns } from "./attendanceNotification.vue?vue&type=template&id=b7468ba8&scoped=true"
import script from "./attendanceNotification.vue?vue&type=script&lang=js"
export * from "./attendanceNotification.vue?vue&type=script&lang=js"
import style0 from "./attendanceNotification.vue?vue&type=style&index=0&id=b7468ba8&prod&scoped=true&lang=css"
import style1 from "./attendanceNotification.vue?vue&type=style&index=1&id=b7468ba8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7468ba8",
  null
  
)

export default component.exports